export default function WhatsAppIcon() {
  return (
    <svg className="social-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M20.5 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20l1.2-4.7a8.5 8.5 0 1 1 16.3-3.8Z" />
      <path d="M8.2 7.3c-.8.4-1 1.6-.5 2.8 1 2.5 3.1 4.7 5.7 5.5 1.3.4 2.4.1 2.7-.8l.3-1.1-2.6-1.2-.9 1c-1.4-.6-2.5-1.7-3.1-3.1l.8-.9-1.2-2.5Z" />
    </svg>
  );
}
